import { createAction } from "typesafe-actions";

import type { WebsiteType } from "../types";

export const selectWebsiteAction = createAction("@@sales/opportunities/SELECT_WEBSITE")<WebsiteType | null>();

export const selectLeadListAction = createAction("@@sales/opportunities/SELECT_LEAD_LIST")<string>();

export const resetOpportunitiesState = createAction("@@sales/opportunities/RESET_STATE")();
